module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mdo4my/tc-custom/9781526767592.jpg?1702542847101",
      "alt": "This image is the cover for the book Knight's Cross Winners of the Waffen SS, Images of War"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Knight's Cross Winners of the Waffen SS, Images of War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A pictorial overview of recipients of Nazi Germany’s military award for bravery.")]), _c('br'), _c('br'), _c('i', [_vm._v("Knight’s Cross Winners of the Waffen-SS")]), _vm._v(" details some of the most-decorated personalities of that infamous organization. Rare photos, including a mix of studio portraits and shots taken in the field, portray prominent members of the SS’s military branch during World War II including Sepp Dietrich, who went from serving as Adolf Hitler’s driver and bodyguard to being elected to the Reichstag; Dachau commandant Theodor Eicke; and tank commander Michael Wittmann.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marc Rikmenspoel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marc Rikmenspoel is the author of several previous books about the Waffen-SS. He wishes current scanning and information-sharing processes were available when he first began writing on this topic over 15 years ago! After many years of living in Colorado, he now lives in the New York City area.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword Military\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0